import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Helmet } from "react-helmet";
import NavbarComponent from "./navbar";
import customericon from "./images/Operation360.webp";
import synergyicon from "./images/synergyicon.webp";
import Fusionicon from "./images/Fusionicon.webp";
import featuretick from "./images/featuretick.webp";
// import offerimg from "./images/offerimg.svg";
import Footer from "./footer";

const Pricing = () => {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const [isYearly, setIsYearly] = useState(false);

  const plans = [
    {
      name: "Operation 360",
      icon: customericon,
      description: "Highlights the comprehensive nature of customer relationship management, aligning with clarity and completeness.",
      monthlyPrice: 2000,
      yearlyPrice: 1500,
      features: [
        "Tickets & Task Flow Management",
        "Lead Management",
        "Digital Document Filing",
        "Sales & Purchase Management",
        "Contact Management",
        "Real-Time Notifications",
        "Customizable Dashboards",
      ],
    },
    {
      name: "Synergy 360",
      icon: synergyicon,
      description: "Captures the collaborative and integrative essence of your business collaboration platform",
      monthlyPrice: 2000,
      yearlyPrice: 1500,
      features: [
        " Vendor, Product, and Service Discovery",
        " Connection and Communication Tools",
        " Product and Service Showcasing",
        " Advanced Search",
        " Collaboration Tools",
        " Multi-Party Communication",
        " Cloud-Based Accessibility",
      ],
    },
    {
      name: "Fusion Pro",
      icon: Fusionicon,
      description: "A professional, all-in-one enterprise solution, combining the best of customer relations and collaboration.",
      monthlyPrice: 2500,
      yearlyPrice: 2000,
      features: [
        "All-in-One Platform",
        " Centralized Operations",
        " Scalable for Enterprise Needs",
        " Data Analytics and Reporting",
        " User Role Management",
        " Seamless Integration",
        " Enterprise-Level Security",
        " Cloud-Based Accessibility",
      ],
    },
  ];


  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "name": "Toodhu Pricing",
    "url": "https://toodhu.com/pricing",
    "description": "Explore Toodhu's pricing plans, from Basic to feature-rich Enterprise, designed to enhance procurement and vendor collaboration for all businesses.",
    "inLanguage": "en",
    "isPartOf": {
      "@type": "WebSite",
      "name": "Toodhu",
      "url": "https://toodhu.com"
    },
    "breadcrumb": {
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://toodhu.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Pricing",
          "item": "https://toodhu.com/pricing"
        }
      ]
    },
    "offers": {
      "@type": "AggregateOffer",
      "url": "https://toodhu.com/pricing",
      "priceCurrency": "INR",
      "lowPrice": "2000",
      "highPrice": "2500",
      "offerCount": "3",
      "offers": [
        {
          "@type": "Offer",
          "name": "Operation 360",
          "price": "6000",
          "priceCurrency": "INR",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "price": "2000",
            "priceCurrency": "INR",
            "billingDuration": 3,
            "billingIncrement": "month"
          },
          "url": "https://toodhu.com/pricing"
        },
        {
          "@type": "Offer",
          "name": "Synergy 360",
          "price": "6000",
          "priceCurrency": "INR",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "price": "2000",
            "priceCurrency": "INR",
            "billingDuration": 3,
            "billingIncrement": "month"
          },
          "url": "https://toodhu.com/pricing"
        },
        {
          "@type": "Offer",
          "name": "Fusion Pro",
          "price": "7500",
          "priceCurrency": "INR",
          "priceSpecification": {
            "@type": "PriceSpecification",
            "price": "2500",
            "priceCurrency": "INR",
            "billingDuration": 3,
            "billingIncrement": "month"
          },
          "url": "https://toodhu.com/pricing"
        }
      ]
    }
  };




  return (

<>
<Helmet>

<title>Toodhu Pricing Plans | Flexible Options for Business Collaboration</title>
<meta charset="utf-8"/>
<meta http-equiv="X-UA-Compatible" content="IE=edge" />
<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1" />
<meta name="description" content="Explore Toodhu's pricing plans, from Basic to feature-rich Enterprise, designed to enhance procurement and vendor collaboration for all businesses."/>
<meta name="keywords" content="Toodhu pricing plans, Business pricing plans, Vendor collaboration pricing"/>
<link rel="canonical" href="https://toodhu.com/pricing" />
<meta name="robots" content="index,follow"/>
<meta property="og:title" content="Toodhu Pricing Plans | Flexible Options for Business Collaboration"/>
<meta property="og:site_name" content="Toodhu"/>
<meta property="og:url" content="https://toodhu.com/pricing"/>
<meta property="og:description" content="Explore Toodhu's pricing plans, from Basic to feature-rich Enterprise, designed to enhance procurement and vendor collaboration for all businesses."/>
<meta property="og:type" content="website"/>
<meta property="og:image" content=""/>
<meta name="twitter:card" content="summary_large_image"/>
<meta name="twitter:site" content="https://toodhu.com/pricing"/>
<meta name="twitter:title" content="Toodhu Pricing Plans | Flexible Options for Business Collaboration"/>
<meta name="twitter:description" content="Explore Toodhu's pricing plans, from Basic to feature-rich Enterprise, designed to enhance procurement and vendor collaboration for all businesses."/>
<meta name="twitter:image" content=""></meta>
<script type="application/ld+json">{JSON.stringify(schemaData)}</script>

</Helmet>


<div>
      <div className="pricing-section">

     <div className="pricingnavbar">
     <NavbarComponent />
     </div>

       
        <section>
          <div className="container text-center">
            <h6 className="toodhupricing">PRICING</h6>
            <h2 className="perfectplan">Unlock Your Perfect Solution</h2>
            <p className="toodhulorem">Choose the perfect solution to streamline your business with Toodhu. Enjoy powerful collaboration, seamless integration, and real-time insights for enhanced productivity.</p>

            <div className="toggle-buttons">
              <button className={`toggle-btn ${!isYearly ? "active" : ""}`} onClick={() => setIsYearly(false)}>Quarterly</button>
              <button className={`toggle-btn ${isYearly ? "active" : ""}`} onClick={() => setIsYearly(true)}>Annual</button>
            </div>

            <div className="row justify-content-center align-items-stretch">
              {plans.map((plan, index) => (
                <div key={index} className="col-xl-4 col-lg-4 col-md-12 col-xs-12 d-flex">
                  <div className={`pricing-box ${plan.name === "Fusion Pro" ? "premium-box" : ""} d-flex flex-column flex-grow-1`}>
                    <h5 className="planname">
                      {plan.icon && <img src={plan.icon} alt={plan.name} className="me-2 icon-style" />}
                      {plan.name}
                    </h5>
                    <p className="plandescription">{plan.description}</p>
                    <div className="d-flex align-items-center gap-2">
                      <h4 className="priceyearormonth">₹{isYearly ? plan.yearlyPrice : plan.monthlyPrice}</h4>
                      <p className="ml-[11px] mt-[24px]">Per User / Month</p>
                    </div>
                    <div className="enjy"><span className="enjyoff">Enjoy Rs. 500/- off</span> after 5 users.</div>
                    <hr/>
                    <ul className="list-unstyled flex-grow-1">
                      {plan.features.map((feature, i) => (
                        <li key={i} className="d-flex align-items-center mb-2">
                          <img src={featuretick} alt="checkmark" className="me-2" style={{ width: "16px", height: "16px" }} />
                          <span className="featurelisted">{feature}</span>
                        </li>
                      ))}
                    </ul>
                    <button className={`btn ${plan.name === "Fusion Pro" ? "btn-dark" : "btn-light"} w-100 getbtn`}>Get Started</button>
                    <div className="minitxt">(Minimum 5 Users for all Subscriptions)</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
      <Footer />
    </div>


</>


  );
};

export default Pricing;